import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';
import { phoneNumberPoolsClient, adminPhoneNumberPoolsClient } from '~/services';

const defaultPhoneNumberPool = () => {
    return {
        friendly_name: '',
    };
};

export const usePhoneNumberPoolDetails = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;

    const phoneNumberPool = ref(defaultPhoneNumberPool());
    const loading = ref(false);
    const saving = ref(false);

    let onMountedPhoneNumberPoolCallback = () => {};
    const onMountedPhoneNumberPool = (callback) => {
        onMountedPhoneNumberPoolCallback = callback;
    };

    const mount = async (phoneNumberPoolId) => {
        phoneNumberPool.value = defaultPhoneNumberPool();

        if (!phoneNumberPoolId) {
            onMountedPhoneNumberPoolCallback?.();
            return;
        }

        phoneNumberPool.value.id = phoneNumberPoolId;
        loading.value = true;

        try {
            const response = await phoneNumberPoolsClient.getById(teamId, phoneNumberPoolId);
            phoneNumberPool.value = response.data;
            loading.value = false;
            onMountedPhoneNumberPoolCallback?.();
        } catch (e) {
            toasted?.error(catchRequestError(e), {
                sticky: true,
            });
        }
    };

    const save = async () => {
        if (saving.value) {
            return;
        }

        saving.value = true;

        try {
            const response = phoneNumberPool.value.id
                ? await adminPhoneNumberPoolsClient.updatePhoneNumberPool(
                      teamId,
                      phoneNumberPool.value.id,
                      phoneNumberPool.value
                  )
                : await adminPhoneNumberPoolsClient.createPhoneNumberPool(teamId, phoneNumberPool.value);

            return response.data;
        } finally {
            saving.value = false;
        }
    };

    return {
        phoneNumberPool,
        loading,
        saving,
        onMountedPhoneNumberPool,
        mount,
        save,
    };
});
